/**
 *
 * @param {string[][]} data 待校验数据
 * @param {[title]: object} currentNodes
 * @returns
 */
export const matrixDataCheck = (data, currentNodes = {}) => {
  for (let i = 0; i < data.length; i++) {
    const row = data[i]
    for (let j = 0; j < row.length; j++) {
      if (row[j].trim() === '') {
        return `第${i + 1}行第${j + 1}列没有数据,请检查`
      }
      if (row[j].length > 100) {
        return `第${i + 1}行第${j + 1}列需要限制在100字以内,请检查`
      }
      if (currentNodes[row[j]]) {
        return `第${i + 1}行第${j + 1}列名称重复,请检查`
      }
    }
  }
  return null
}
